import { emailAddress } from 'utils'

interface UIInfo {
  email?: string
  domain?: string
  fileIconMap?: Record<string, FileIconState>
}

export interface FileIconState {
  imgSrc?: string
  alt?: string
  text?: string
}

export const uiInfo: UIInfo = {}

export function getEmailName(email: string): string {
  const pos = email.indexOf('@')
  return email.substring(0, pos)
}

export function setUserEmail(email: string): void {
  uiInfo.email = email
}

export function getUserEmail(): string | undefined {
  return uiInfo.email
}

export function getUserDomain(): string | undefined {
  if (uiInfo.domain == null && uiInfo.email != null) {
    uiInfo.domain = `@${emailAddress(uiInfo.email).host}`
  }

  return uiInfo.domain
}

const emailRegex =
  /^[a-zA-Z0-9\+\.\_\%\-\+]{1,256}\@[a-zA-Z0-9][a-zA-Z0-9\-]{0,64}(\.[a-zA-Z0-9][a-zA-Z0-9\-]{1,63})+$/

export function isEmail(emailStr?: string | null): boolean {
  if (emailStr == null || emailStr.length === 0) {
    return false
  }

  const isEmail = emailRegex.test(emailStr)
  return isEmail
}
